import getEnv from '@clearscore/helpers.envs';

const NATIVE_BRIDGE = 'nativeBridge';
const NATIVE_BRIDGE_FUNCTION = 'stream';

/**
 * Checks to see if the device supports safari messageHandlers
 */
function _hasIosBridge() {
    const useIosBridge = getEnv('ENABLE_IOS_MESSAGE_HANDLER');
    return !!(
        useIosBridge &&
        window &&
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.callback &&
        window.webkit.messageHandlers.callback &&
        typeof window.webkit.messageHandlers.callback.postMessage === 'function'
    );
}

/**
 * Checks to see if the native bridge is present
 * @return Boolean
 * @private
 */
function _hasNativeBridge() {
    return !!(
        window &&
        window[NATIVE_BRIDGE] &&
        window[NATIVE_BRIDGE][NATIVE_BRIDGE_FUNCTION] &&
        typeof window[NATIVE_BRIDGE][NATIVE_BRIDGE_FUNCTION] === 'function'
    );
}

/**
 * Check for any data bridge
 * @param {*} next
 * @param {*} action
 */
function _hasBridge() {
    return _hasIosBridge() || _hasNativeBridge();
}

/**
 * Send the action to the native bridge and continue
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @returns {void}
 */
function _sendAction(next, action) {
    const message = JSON.stringify(action);
    if (_hasIosBridge()) {
        window.webkit.messageHandlers.callback.postMessage(message);
    } else {
        window[NATIVE_BRIDGE][NATIVE_BRIDGE_FUNCTION](message);
    }
    next(action);
}

/**
 * If native bridge is available then send the action to the native bridge
 * @returns {Function} middleware
 */
const nativeBridgeMiddleware = () => () => (next) => (action) =>
    _hasBridge() ? _sendAction(next, action) : next(action);

export default nativeBridgeMiddleware;
